import { HOME_TRACKING_SOURCE } from './tracking';
import { SourceType } from '../analytics/click-through-tracking/TrackingSource';
import { SeoFooterTab } from '@property.com.au/ui-kit/dist/types/libraries/footer/public/SeoFooterTabs/SeoFooterTabs';

const forSale = {
  name: 'Real estate for sale',
  tabContent: {
    title: 'Properties for sale',
    links: [
      {
        title: 'ACT properties for sale',
        url: '/act/buy/',
        pathname: '/act/buy/',
      },
      {
        title: 'TAS properties for sale',
        url: '/tas/buy/',
        pathname: '/tas/buy/',
      },
      {
        title: 'Brisbane properties for sale',
        url: '/qld/brisbane-city-4000/buy/',
        pathname: '/qld/brisbane-city-4000/buy/',
      },
      {
        title: 'NSW properties for sale',
        url: '/nsw/buy/',
        pathname: '/nsw/buy/',
      },
      {
        title: 'VIC properties for sale',
        url: '/vic/buy/',
        pathname: '/vic/buy/',
      },
      {
        title: 'Adelaide properties for sale',
        url: '/sa/adelaide-5000/buy/',
        pathname: '/sa/buy/',
      },
      {
        title: 'NT properties for sale',
        url: '/nt/buy/',
        pathname: '/nt/buy/',
      },
      {
        title: 'Canberra properties for sale',
        url: '/act/canberra-greater-region/buy/',
        pathname: '/act/canberra-greater-region/buy/',
      },
      {
        title: 'Hobart properties for sale',
        url: '/tas/hobart-7000/buy/',
        pathname: '/tas/hobart-7000/buy/',
      },
      {
        title: 'QLD properties for sale',
        url: '/qld/buy/',
        pathname: '/qld/buy/',
      },
      {
        title: 'Sydney properties for sale',
        url: '/nsw/sydney-cbd/buy/',
        pathname: '/nsw/sydney-cbd/buy/',
      },
      {
        title: 'Melbourne properties for sale',
        url: '/vic/melbourne-city-greater-region/buy/',
        pathname: '/vic/melbourne-city-greater-region/buy/',
      },
      {
        title: 'SA properties for sale',
        url: '/sa/buy/',
        pathname: '/sa/buy/',
      },
      {
        title: 'Darwin properties for sale',
        url: 'nt/darwin-greater-region/buy/',
        pathname: 'nt/darwin-greater-region/buy/',
      },

      {
        title: 'WA properties for sale',
        url: '/wa/buy/',
        pathname: '/wa/buy/',
      },

      {
        title: 'Perth properties for sale',
        url: '/wa/perth-greater-region/buy/',
        pathname: '/wa/perth-greater-region/buy/',
      },
    ].map((link) => ({
      title: link.title,
      url: link.url,
      clickThroughTracking: {
        page: HOME_TRACKING_SOURCE,
        element: 'footer-nav-for-sale-tab',
        sourceType: SourceType.web,
        pathname: link.pathname,
      },
    })),
  },
} satisfies SeoFooterTab;

const forRent = {
  name: 'Real estate for rent',
  tabContent: {
    title: 'Rental properties',
    links: [
      {
        title: 'ACT rental properties',
        url: '/act/rent/',
        pathname: '/act/rent/',
      },
      {
        title: 'TAS rental properties',
        url: '/tas/rent/',
        pathname: '/tas/rent/',
      },
      {
        title: 'Brisbane rental properties',
        url: '/qld/brisbane-city-4000/rent/',
        pathname: '/qld/brisbane-city-4000/rent/',
      },
      {
        title: 'NSW rental properties',
        url: '/nsw/rent/',
        pathname: '/nsw/rent/',
      },
      {
        title: 'VIC rental properties',
        url: '/vic/rent/',
        pathname: '/vic/rent/',
      },
      {
        title: 'Adelaide rental properties',
        url: '/sa/adelaide-5000/rent/',
        pathname: '/sa/rent/',
      },
      {
        title: 'NT rental properties',
        url: '/nt/rent/',
        pathname: '/nt/rent/',
      },
      {
        title: 'Canberra rental properties',
        url: '/act/canberra-greater-region/rent/',
        pathname: '/act/canberra-greater-region/rent/',
      },
      {
        title: 'Hobart rental properties',
        url: '/tas/hobart-7000/rent/',
        pathname: '/tas/hobart-7000/rent/',
      },
      {
        title: 'QLD rental properties',
        url: '/qld/rent/',
        pathname: '/qld/rent/',
      },
      {
        title: 'Sydney rental properties',
        url: '/nsw/sydney-cbd/rent/',
        pathname: '/nsw/sydney-cbd/rent/',
      },
      {
        title: 'Melbourne rental properties',
        url: '/vic/melbourne-city-greater-region/rent/',
        pathname: '/vic/melbourne-city-greater-region/rent/',
      },
      {
        title: 'SA rental properties',
        url: '/sa/rent/',
        pathname: '/sa/rent/',
      },
      {
        title: 'Darwin rental properties',
        url: '/nt/darwin-greater-region/rent/',
        pathname: '/nt/darwin-greater-region/rent/',
      },
      {
        title: 'WA rental properties',
        url: '/wa/rent/',
        pathname: '/wa/rent/',
      },
      {
        title: 'Perth rental properties',
        url: '/wa/perth-greater-region/rent/',
        pathname: '/wa/perth-greater-region/rent/',
      },
    ].map((link) => ({
      title: link.title,
      url: link.url,
      clickThroughTracking: {
        page: HOME_TRACKING_SOURCE,
        element: 'footer-nav-for-rent-tab',
        sourceType: SourceType.web,
        pathname: link.pathname,
      },
    })),
  },
} satisfies SeoFooterTab;

const suburbs = {
  name: 'Explore suburbs',
  tabContent: {
    title: 'Find suburbs in state',
    links: [
      {
        title: 'ACT profile',
        url: '/act/',
        pathname: '/act/',
      },
      {
        title: 'VIC profile',
        url: '/vic/',
        pathname: '/vic/',
      },
      {
        title: 'SA profile',
        url: '/sa/',
        pathname: '/sa/',
      },
      {
        title: 'NT profile',
        url: '/nt/',
        pathname: '/nt/',
      },
      {
        title: 'QLD profile',
        url: '/qld/',
        pathname: '/qld/',
      },
      {
        title: 'NSW profile',
        url: '/nsw/',
        pathname: '/nsw/',
      },
      {
        title: 'TAS profile',
        url: '/tas/',
        pathname: '/tas/',
      },
      {
        title: 'WA profile',
        url: '/wa/',
        pathname: '/wa/',
      },
    ].map((link) => ({
      title: link.title,
      url: link.url,
      clickThroughTracking: {
        page: HOME_TRACKING_SOURCE,
        element: 'footer-nav-suburbs-tab',
        sourceType: SourceType.web,
        pathname: link.pathname,
      },
    })),
  },
} satisfies SeoFooterTab;

export const seoFooterTabs: SeoFooterTab[] = [forSale, forRent, suburbs];
